module.exports = __webpack_public_path__ + "img/header_logo.51b55d3a.png";